import { SELECT_THEME } from './constants';
import themes from './themes';

export const initialState = {
    selectedTheme: 'default',
    themes,
};

function themeProviderReducer(state = initialState, action) {
    switch (action.type) {
        case SELECT_THEME:
            return {
                ...state,
                selectedTheme: action.theme,
            };
        default:
            return state;
    }
}

export default themeProviderReducer;
